export default {}



/** WEBPACK FOOTER **
 ** ./~/.5.0.0@standard-loader!./src/root.js
 **/